import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { changeProfitDropOffer } from '@/redux/reducers/shopReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

interface SwitchCardsButtonProps {
  variant?: 'default' | 'transparent';
}

const SwitchCardsButton: React.FC<SwitchCardsButtonProps> = ({ variant }) => {
  const { t } = useTranslation();
  const profitDropOffers = useAppSelector(
    (state) => state.shop.profitDropOffers,
  );
  const id = useAppSelector((state) => state.shop.activeProfitDropOffer?.id);
  const dispatch = useAppDispatch();

  if (!profitDropOffers.length) return null;

  return (
    <div
      className={cn(
        'flex-1 backdrop-blur-sm rounded-[6px] p-[2px] flex h-full',
        variant === 'transparent' ? 'bg-white/10' : 'bg-main-bg',
      )}
    >
      {profitDropOffers.map((card) => (
        <div
          className={cn(
            'flex-1 flex items-center justify-center rounded-[4px] !text-[12px] !font-[700]',
            card.id === id ? 'bg-white/20' : 'text-white/40',
          )}
          key={card.id}
          onClick={() => dispatch(changeProfitDropOffer(card))}
        >
          {card.name === 'profitDropSmall' ? t('Small') : t('Big')}
        </div>
      ))}
    </div>
  );
};

export default SwitchCardsButton;
